<template>
  <div id="app">
    <!--<router-view/>-->
    <router-view/>
  </div>
</template>

<style>
.el-message {
  z-index: 99999999 !important;
}
</style>
<script>
  export default {
    name: 'App',
    data(){
      return{
      }
    },

    methods: {
    }

  }
</script>
